import { render, staticRenderFns } from "./vuedraggable.vue?vue&type=template&id=78c82658&scoped=true&"
import script from "./vuedraggable.vue?vue&type=script&lang=js&"
export * from "./vuedraggable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78c82658",
  null
  
)

export default component.exports